/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Component } from '@angular/core';

/**
 * Generated class for the EntryDancersComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'entry-dancers-component',
  templateUrl: 'entry-dancers-component.html'
})
export class EntryDancersComponent {

  text: string;

  constructor() {
    console.log('Hello EntryDancersComponent Component');
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/entry-dancers-component/entry-dancers-component.ts